"use client";

import { initApiClient } from "@linqx/api-client/client";
import { registerConfigValues } from "@linqx/config";

let initialized = false;

/**
 * Backend host the waitlist API is called against.
 *
 * Sourced from `import.meta.env.VITE_API_HOST` (bridged from the repo's env in
 * vite.config: VITE_API_HOST / EXPO_PUBLIC_API_HOST / API_HOST). Falls back to
 * the production API host so a deployed landing always reaches the real backend
 * even if the build-time env var is missing.
 */
const API_HOST =
  (import.meta.env.VITE_API_HOST as string | undefined)?.trim() ||
  "https://api.getlinqx.com";

/**
 * Initialize the API client for the landing page.
 * Safe to call multiple times - only initializes once.
 */
export function initLandingApi(): void {
  if (initialized) return;

  // Point the generated client at the backend host (basePath = config.apiHost).
  registerConfigValues({ apiHost: API_HOST });

  initApiClient({
    getUserAgent: () => "Linqx-Landing/1.0",
    extraHeaders: {
      "X-Client-Platform": "web",
      "X-App-Version": "1.0.0",
    },
  });

  initialized = true;
}
